import CustomLineChart from 'components/charts/lineChart';
import DotsLoading from 'components/loadings/dotsLoading';
import React from 'react';
import useGetSuggestionChart from './hooks/useGetSuggestionChart';
import useGetChartPost from '../hooks/useGetChartPost';

import {calclulateTotal, calculateUndefindValue, concatDates} from './hepler';
interface AuctionChartProps {
  guid: string;
  app: 'farm' | 'wholesaler';
}
const AuctionChart = ({guid, app}: AuctionChartProps) => {
  const {auctionSuggestionChartIloading, AuctionSuggestionData} =
    useGetSuggestionChart(guid);
  const {postChartData, isLoading} = useGetChartPost(guid);

  const newDates = concatDates(postChartData, AuctionSuggestionData);
  const newPostChartData = calculateUndefindValue(
    postChartData ? postChartData : [],
    newDates,
  );
  const newAuctiondata = calculateUndefindValue(
    AuctionSuggestionData
      ? AuctionSuggestionData.map(item => {
          return {date: item.created_at__date, count: item.count};
        })
      : [],
    newDates,
  );

  return (
    <div className="w-full flex flex-col gap-4">
      <h4 className="flex items-center gap-2 text-gray-6 text-[16px] font-normal">
        <span className="w-2 h-2 flex rounded-full bg-primary" />
        آمار بازدید
      </h4>
      <h4 className="flex items-center gap-2 text-gray-6 text-[16px] font-normal">
        <span className="w-2 h-2 flex rounded-full bg-green-1" />
        پیشنهادات ثبت شده:
        <span>
          {calclulateTotal(AuctionSuggestionData ? AuctionSuggestionData : [])}
        </span>
      </h4>
      {auctionSuggestionChartIloading || isLoading ? (
        <>
          <DotsLoading />
        </>
      ) : (
        <>
          <CustomLineChart
            data={{
              labels: newDates,
              datasets: [
                {
                  data: newPostChartData?.map(item => item.count),
                  borderColor: app === 'farm' ? '#F29E4C' : '#38B3B5',
                  fill: false,
                },
                {
                  data: newAuctiondata?.map(item => item?.count),
                  borderColor: '#16DB93',
                  fill: false,
                },
              ],
            }}
            yAxisTitleOption={{
              display: true,
              text: 'نفر',
              align: 'end',
              font: {size: 12, family: 'IRANSans'},
            }}
            yTick={{
              callback: function (label) {
                // when the floored value is the same as the value we have a whole number
                if (typeof label === 'number') {
                  if (Math.floor(label) === label) {
                    return label;
                  }
                }
              },
            }}
          />
        </>
      )}
    </div>
  );
};

export default AuctionChart;
